// extracted by mini-css-extract-plugin
export var labelWrapper = "_hl-0";